import React from "react";
import styled from "@emotion/styled";
import { Power } from "react-feather";
import { useNavigate } from "react-router-dom";

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";
import { current } from "@reduxjs/toolkit";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const { signOut } = useAuth();

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSettings = () => {
    //if (currentUser?.id) navigate(`/settings/${currentUser.id}`);
    closeMenu();
    if (currentUser?.id) navigate(`/users/settings/${currentUser.id}`);
  };
  const handleAssociationInvoices = () => {
    closeMenu();
    if (currentUser)
      navigate(`/associations/invoices/${currentUser.activeAssociation.id}`);
  };

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <React.Fragment>
      <Tooltip title="Tili">
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
        >
          <Power />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        {/* <MenuItem onClick={closeMenu}>Profile</MenuItem> */}
        <MenuItem onClick={handleAssociationInvoices}>Tilaus</MenuItem>
        <MenuItem onClick={handleSettings}>Asetukset</MenuItem>
        <MenuItem onClick={handleSignOut}>Kirjaudu ulos</MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
